import React, { PureComponent } from 'react'
import PropTypes from 'prop-types'
import classNames from 'classnames'
import { Card as AntCard } from 'antd'
import './Card.less'

export default class Card extends PureComponent {
  render() {
    const { className, showGradient, ...others } = this.props
    const CardClassName = classNames(className, 'pan-card', showGradient ? 'with-gradient' : '')
    const CardProps = {
      className: CardClassName,
      title: this.props.header || this.props.title,
    }
    return <AntCard {...others} {...CardProps} />
  }
}

Card.propTypes = {
  hoverable: PropTypes.bool,
  showGradient: PropTypes.bool
}

Card.AntCard = AntCard
